import InboomaBaseAsyncCollection from './InboomaBaseAsyncCollection';
import Event from '../models/Event';

export default InboomaBaseAsyncCollection.extend({

    collectionName : 'events',
    model : Event,
    url : '/events',
    _skipPagination: true

});